import React from 'react';
import { sortBasedOnList } from '../utils';

export type Table3aData = { [key: string]: { data: { [key: string]: ITable3aRow } } };

interface ITable3aRow {
  crashesTotal: number;
  crashesFatal: number;
  crashesInjuryA: number;
  crashesInjuryB: number;
  crashesInjuryC: number;
  crashesPDO: number;
  personsFatal: number;
  personsInjuryA: number;
  personsInjuryB: number;
  personsInjuryC: number;
  ratesFatal: number;
  ratesInjuryA: number;
}

export interface ITable3aProps {
  data: Table3aData;
  standardSummaryTypeId: number;
}

const sortOrder = [
  "Interstate",
  "Principal Arterial - Freeways and Expressways",
  "Principal Arterial - Other",
  "Minor Arterial",
  "Major Collector",
  "Minor Collector",
  "Local",
]

export default class Table3a extends React.Component<ITable3aProps> {
  constructor(props: ITable3aProps) {
    super(props);
  }

  render() {
    return (
      this.props.data ?
        <table className="ss-table summaryTable1">
          <colgroup>
            <col style={{ width: '20px' }} />
            <col style={{ width: '347px' }} />
            <col style={{ width: '65px' }} />
            <col style={{ width: '65px' }} />
            <col style={{ width: '65px' }} />
            <col style={{ width: '65px' }} />
            <col style={{ width: '65px' }} />
            <col style={{ width: '65px' }} />
            <col style={{ width: '65px' }} />
            <col style={{ width: '65px' }} />
            <col style={{ width: '65px' }} />
            <col style={{ width: '65px' }} />
            <col style={{ width: '89px' }} />
            <col style={{ width: '89px' }} />
          </colgroup>
          <thead>
            <tr>
              <th rowSpan={3} colSpan={2} className="border-right-bold">
                <div className="ss-table-header">
                  <span className="header-number" style={{ border: 'none' }}>3a</span>
                  <div style={{ width: '3px', height: '96px', backgroundColor: 'black' }} />
                  <span className="header-text">ROADWAY</span>
                </div>
              </th>
              <th colSpan={6} className="border-right-bold">CRASHES</th>
              <th colSpan={4} className="border-right-bold">PERSONS</th>
              <th colSpan={2} className="border-right-bold">
                RATES
                <br />
                (Injuries Per 100 Million Vehicle Miles)
              </th>
            </tr>
            <tr>
              <th rowSpan={2}>TOTAL</th>
              <th rowSpan={2}>FATAL</th>
              <th colSpan={3}>INJURY</th>
              <th rowSpan={2} className="border-right-bold">PDO</th>
              <th rowSpan={2}>KILLED</th>
              <th colSpan={3} className="border-right-bold">INJURY</th>
              <th rowSpan={2}>KILLED</th>
              <th rowSpan={2}>A*</th>
            </tr>
            <tr>
              <th>A*</th>
              <th>B*</th>
              <th>C*</th>
              <th>A*</th>
              <th>B*</th>
              <th className="border-right-bold">C*</th>
            </tr>
          </thead>
          <tbody>
            {Object.keys(this.props.data).map((key, index) =>
              sortBasedOnList(this.props.data[key], sortOrder).map((key2, index2) =>
                <tr
                  key={key2}
                  style={index > 0 && index2 === 0 ? { borderTop: '2px solid black' } : {}}
                >
                  {index2 === 0 &&
                    <td rowSpan={Object.keys(this.props.data[key]).length}>
                      <p
                        className="atIntersectionVerticalColumnSmall"
                        style={{
                          textAlign: 'center',
                          width: '15px',
                          transform: 'rotate(270deg)',
                          position: 'relative',
                          top: '16px',
                          left: '1px',
                          margin: 0,
                        }}
                      >
                        {key}
                      </p>
                    </td>
                  }
                  <td className="border-right-bold">{key2}</td>
                  <td className="numberTotals">{this.props.data[key][key2].crashesTotal}</td>
                  <td className="numberTotals">{this.props.data[key][key2].crashesFatal}</td>
                  <td className="numberTotals">{this.props.data[key][key2].crashesInjuryA}</td>
                  <td className="numberTotals">{this.props.data[key][key2].crashesInjuryB}</td>
                  <td className="numberTotals">{this.props.data[key][key2].crashesInjuryC}</td>
                  <td className="numberTotals border-right-bold">{this.props.data[key][key2].crashesPDO}</td>
                  <td className="numberTotals">{this.props.data[key][key2].personsFatal}</td>
                  <td className="numberTotals">{this.props.data[key][key2].personsInjuryA}</td>
                  <td className="numberTotals">{this.props.data[key][key2].personsInjuryB}</td>
                  <td className="numberTotals border-right-bold">{this.props.data[key][key2].personsInjuryC}</td>
                  {this.props.standardSummaryTypeId === 3 ?
                    <>
                      <td className="numberTotals">{this.props.data[key][key2].ratesFatal}</td>
                      <td className="numberTotals">{this.props.data[key][key2].ratesInjuryA}</td>
                    </>
                    :
                    <>
                      <td className="numberTotals" style={{ backgroundColor: 'darkgray' }}></td>
                      <td className="numberTotals" style={{ backgroundColor: 'darkgray' }}></td>
                    </>
                  }
                </tr>)
            )}
          </tbody>
        </table>
        : <p>Loading...</p>
    )
  }
};
